export const getClientTimezone = (): string | undefined => {
  if (typeof Intl === 'undefined' || typeof Intl.DateTimeFormat !== 'function') {
    return undefined;
  }

  try {
    const { timeZone } = new Intl.DateTimeFormat().resolvedOptions();
    if (typeof timeZone === 'string') {
      const trimmed = timeZone.trim();
      if (trimmed.length > 0) {
        return trimmed;
      }
    }
  } catch (error) {
    if (import.meta.env?.DEV) {
      console.warn('[timezone] failed to detect client timezone', error);
    }
  }

  return undefined;
};
